import type { ReactNode } from 'react';

export const symbol_transform: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M290-607H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-667 110-667h180v-139l-59 59q-9 9-21 9t-21.39-9q-8.61-9-8.61-21t9-21l110-110q9-9 21-9t21 9l110 110q9 9 9 21t-8.61 21q-9.39 9-21.39 9t-21-9l-59-59v453h500q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H670v139l59-59q9-9 21-9t21.39 9q8.61 9 8.61 21t-9 21L661-61q-9 9-21 9t-21-9L509-171q-9-9-9-21t8.61-21q9.39-9 21.39-9t21 9l59 59v-139H350q-26 0-43-17t-17-43v-254Zm320 194v-194H410v-60h200q26 0 43 17t17 43v194h-60Z"
		/>
	</svg>
);
